{
  "error": "Erro",
  "help": "Ajuda",
  "info": "Informações",
  "success": "Sucesso",
  "warning": "Aviso"
}
